import type {
  CustomMenuLabels,
  FilterSelectItem,
} from '@jane/search/data-access';
/* eslint-disable-next-line no-restricted-imports */
import type { Store } from '@jane/shared/models';

import { CATEGORY_COLORS, CATEGORY_ICONS } from './constants';
import { facetToFilter } from './facetToFilter';
import { sortAndFilterCategories } from './sortAndFilterCategories';

interface BuildCategoryFilterItemsOptions {
  branded?: boolean;
  /** A category page filters by subtypes of a single category, not by root types. */
  categoryPage?: boolean;
  customLabels?: CustomMenuLabels['root_types'];
  customRanking?: Store['custom_product_type_ranking'];
  menuTabs?: Store['menu_tabs'];
  rootTypeFacets: { [label: string]: number };
  storeId?: Store['id'];
  storeState?: string | null;
}

/**
 * Builds the items for the Category filter group, in the arrangement the store's
 * menu uses. Rows - both Jane defined (`sale`, `best_selling`) and store custom
 * rows - are dropped, since the Categories section only offers product categories.
 */
export const buildCategoryFilterItems = ({
  branded = true,
  categoryPage = false,
  customLabels,
  customRanking,
  menuTabs,
  rootTypeFacets,
  storeId,
  storeState,
}: BuildCategoryFilterItemsOptions): FilterSelectItem[] => {
  const items = facetToFilter(
    rootTypeFacets,
    {
      branded,
      customLabels,
      filterGroup: categoryPage ? 'Subcategory' : 'Category',
      iconColor: branded ? CATEGORY_COLORS : undefined,
      icons: CATEGORY_ICONS,
      storeId,
    },
    storeState
  );

  // A category page's facets are subtypes, and without a store there is no menu
  // arrangement to sort against, so in both cases the facets are rendered as-is.
  if (categoryPage || !storeId) {
    return items;
  }

  return sortAndFilterCategories(items, customRanking, menuTabs);
};
